import { render } from "./CounterComponent.vue?vue&type=template&id=8fc45bdc&ts=true"
import script from "./CounterComponent.vue?vue&type=script&lang=ts"
export * from "./CounterComponent.vue?vue&type=script&lang=ts"

import "./CounterComponent.vue?vue&type=style&index=0&id=8fc45bdc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__